import { createContext, useContext } from 'react';

/**
 * `true` once LD has loaded flags for the actually-signed-in user. The
 * provider boots with an anonymous context, so until `identify()` resolves,
 * flag reads reflect the anonymous variation — gating auth-restricted UI on
 * those values redirects users away before LD has had a chance to evaluate
 * their flags.
 */
export const ldIdentifiedContext = createContext(false);

export const useLDIdentified = (): boolean => useContext(ldIdentifiedContext);
